let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("49C5w")).then(() => parcelRequire('jQsne'));